import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";
import { Eye, EyeOff } from "lucide-react";

const Viewpr_new = () => {
   useAuthRedirect();
    const {prNo} = useParams();
  const branch = localStorage.getItem("branch");
  const [indentView, setIndentView] = useState({});
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const [data, setData] = useState([]);

   //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canView  = hasPermission("purchase-Requisition", "view");
              const canDel = hasPermission("purchase-Requisition", "del");
              /////////////////////////////////////////////////////////////


  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        Swal.fire({
                          title: "Fetching Purchase Details",
                          html: `
                            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                            </div>
                            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Purchase Details...</p>
                          `,
                          showConfirmButton: false,
                          allowOutsideClick: false,
                          didOpen: () => {
                            const style = document.createElement("style");
                            style.innerHTML = `
                              @keyframes progressBar {
                                0% { width: 0% }
                                50% { width: 100% }
                                100% { width: 0% }
                              }
                            `;
                            document.head.appendChild(style);
                          },
                        });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseReq_detailsHeader?prNo=${prNo}&branch=${branch}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                fld_now: items[0].fld_now || "N/A",
                fld_dept: items[0].fld_dept || "N/A",
                fld_inref: items[0].fld_inref || "N/A",
                fld_hod: items[0].fld_hod || "N/A",
                fld_requbasis: items[0].fld_requbasis || "N/A",
                fld_headmet: items[0].fld_headmet || "N/A",
                fld_prepared: items[0].fld_prepared || "N/A",
                fld_remarks: items[0].fld_remarks || "N/A",
            };

            setIndentView(storeReqHeader);
        }
        Swal.close();
      } catch (error) {
        Swal.close();
                        console.error("Error fetching Purchase Details. Please try again:", error);
                        Swal.fire({
                          icon: "error",
                          title: "Oops!",
                          text: "Error fetching Purchase Details. Please try again",
                        });
      }
    };

    {canView && (
    fetchIndentDetails()
    )}
  }, [prNo, branch]); 

  useEffect(() => {
    axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseReq_detailsBottom?prNo=${prNo}`)
    .then((response) => {
      Swal.fire({
                          title: "Fetching Purchase Details",
                          html: `
                            <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                              <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                            </div>
                            <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Purchase Details...</p>
                          `,
                          showConfirmButton: false,
                          allowOutsideClick: false,
                          didOpen: () => {
                            const style = document.createElement("style");
                            style.innerHTML = `
                              @keyframes progressBar {
                                0% { width: 0% }
                                50% { width: 100% }
                                100% { width: 0% }
                              }
                            `;
                            document.head.appendChild(style);
                          },
                        });
                        {canView && (
      setData(response.data.bottomDetails)
                        )}
     Swal.close(); 
    })
    .catch((error) => {
         Swal.close();
                        console.error("Error fetching Purchase Details. Please try again:", error);
                        Swal.fire({
                          icon: "error",
                          title: "Oops!",
                          text: "Error fetching Purchase Details. Please try again",
                        });
    })
}, [prNo]); 

const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
                      title: "Submitting...",
                      text: "Please wait while we process your request.",
                      allowOutsideClick: false,
                      didOpen: () => {
                          Swal.showLoading();
                      },
                  });

          await axios.delete(`https://rfs2.infraconsoft.net.in/api/purcahse_req_delete/${id}`);
          setData(data.filter((item) => item.fld_purid !== id));

          Swal.fire({
            title: "Deleted!",
            text: "Your record has been deleted.",
            icon: "success"
          });
          
        } catch (error) {
          console.error("Error deleting:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to delete vehicle position.",
            icon: "error"
          });
        }
      }
    });
  };

if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Purchase Requisition - View</h2>
                    <Link to='/inventory/purchasesreqView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
          <div className="form-row">
              <div className="form-group">
                <label>Purchase No :</label>
                <input type="text" name="indentNo" value={prNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="text" name="endhrs" value={indentView.fld_now ? new Date(indentView.fld_now).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Indent Ref :</label>
                <input type="text" name="indentNo" value={indentView.fld_inref} readOnly/>
              </div>
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" value={indentView.fld_hod} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Department :</label>
                <input type="text" name="indentNo" value={indentView.fld_dept} readOnly/>
              </div>
              <div className="form-group">
                <label>Head Material :</label>
                <input type="text" value={indentView.fld_headmet} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Requirment basis :</label>
                <input type="text" name="indentNo" value={indentView.fld_requbasis} readOnly/>
              </div>
             
              <div className="form-group">
                <label>Prepared By :</label>
                <input type="text" value={indentView.fld_prepared} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={indentView.fld_remarks} name="remarks" readOnly />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>


            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Price</th>
                    <th>Qty</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                    
                                        {showLifeDetail && (
                      <th style={{ textAlign: "center" }}>
                        Life Detail
                      </th>
                    )}
                    {canDel && (
                    <th>Delete</th>
                    )}
                                        <th>
                                          <button
                                            type="button"
                                            onClick={() => setShowLifeDetail(!showLifeDetail)}
                                            style={{
                                              background: "none",
                                              border: "none",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                                          </button>
                                        </th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.fld_itemcode}</td>
                        <td>{item.fld_desc}</td>
                        <td>{item.fld_drawno}</td>
                        <td>{item.fld_uom}</td>
                        <td>{item.fld_price}</td>
                        <td>{item.fld_qty}</td>
                        <td>{new Date(item.fld_duedate).toLocaleDateString("en-GB")}</td>
                        <td>{item.fld_specification}</td>
                        <td>{item.fld_purpose}</td>
                                                 {showLifeDetail && (
 <td>{item.fld_lifetime}</td>  
                )}
                        
                        {canDel && (
                        <td className="del">
                      <i className="fa-solid fa-trash-can " onClick={() => handleDelete(item.fld_purid)}></i>
                    </td>
                        )}

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>

    </div>
  );
};

export default Viewpr_new;
